// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".placeholder-wrapper{align-content:center;aspect-ratio:600/395;background-color:#c5bfb0;border-radius:8px;display:none;flex-wrap:wrap;grid-column:span 2;justify-content:center;width:100%}.placeholder-wrapper:has(:first-child:not(:empty)),.placeholder-wrapper:has(:last-child:not(:empty)){display:flex}.product-list{padding:2rem 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
